export var mutations = {
    setLandingPage: function (state, landingPage) {
        state.landingPage = landingPage;
    },
    setLandingPageNotFound: function (state, found) {
        state.landingPageNotFound = found;
    },
    setLoadingLandingPage: function (state, loading) {
        state.loadingLandingPage = loading;
    },
};
export var types = {
    SET_LANDING_PAGE: 'setLandingPage',
    SET_LOADING_LANDING_PAGE: 'setLoadingLandingPage',
    SET_LANDING_PAGE_NOT_FOUND: 'setLandingPageNotFound',
};
